/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFileDownload = createReactComponent("file-download", "IconFileDownload", [
  ["path", { d: "M14 3v4a1 1 0 0 0 1 1h4", key: "svg-0" }],
  [
    "path",
    {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z",
      key: "svg-1"
    }
  ],
  ["path", { d: "M12 17v-6", key: "svg-2" }],
  ["path", { d: "M9.5 14.5l2.5 2.5l2.5 -2.5", key: "svg-3" }]
]);

export { IconFileDownload as default };
//# sourceMappingURL=IconFileDownload.js.map
